import { __experimentalGetGapCSSValue as getGapCSSValue } from '@wordpress/block-editor';
import { getBreakpoints } from '@groundworx/utils';

export default function LayoutStyles({ attributes, clientId }) {
	const { breakpoints: layoutBreakpoints = {} } = attributes;

	const blockGap = attributes.style?.spacing?.blockGap;

	const fallbackValue = 'var(--wp--style--block-gap, 0px)';
	let row = fallbackValue;
	let column = fallbackValue;

	if (blockGap) {
		row = typeof blockGap === 'string'
			? getGapCSSValue(blockGap)
			: getGapCSSValue(blockGap?.top) || fallbackValue;

		column = typeof blockGap === 'string'
			? getGapCSSValue(blockGap)
			: getGapCSSValue(blockGap?.left) || fallbackValue;
	}

	const gapValue = row === column ? row : `${row} ${column}`;

	const sortedBreakpoints = Object.entries(layoutBreakpoints).sort(([a], [b]) => {
		return getBreakpoints.resolve(a) - getBreakpoints.resolve(b);
	});

	const rules = sortedBreakpoints.map(([breakpointKey, data]) => {
		const minWidth = getBreakpoints.get(breakpointKey);
		if (!minWidth) return '';

		const hasGridLayout = data?.layout?.type === 'grid';
		const hasSameHeight = data?.sameHeight !== undefined;

		// Skip breakpoints that have neither grid layout nor explicit sameHeight
		if (!hasGridLayout && !hasSameHeight) return '';

		const { sameHeight, layout } = data;
		const baseSelector = `#block-${clientId} > .gwx-carousel.is-destroyed .gwx-carousel__container`;

		// If we have a full grid layout, generate complete grid rules
		if (hasGridLayout) {
			const { columnCount, minimumColumnWidth } = layout;
			const declarations = [`gap: ${gapValue};`];

			if (sameHeight === true) {
				declarations.push(`grid-auto-rows: minmax(0,1fr);`);
			} else if (sameHeight === false) {
				declarations.push(`grid-auto-rows: auto;`);
			}

			if (minimumColumnWidth) {
				declarations.push(
					`grid-template-columns: repeat(auto-fill, minmax(min(${minimumColumnWidth}, 100%), 1fr));`,
					`container-type: inline-size;`
				);
			} else if (columnCount) {
				declarations.push(
					`grid-template-columns: repeat(${parseInt(columnCount)}, minmax(0, 1fr));`
				);
			}

			return `@media (min-width: ${minWidth}) {
			${baseSelector} {
				display: grid;
				${declarations.join('\n')}
			}
		}`;
		}

		// No grid layout but has explicit sameHeight — output just the row height rule
		if (hasSameHeight) {
			const rowRule = sameHeight
				? `grid-auto-rows: minmax(0,1fr);`
				: `grid-auto-rows: auto;`;

			return `@media (min-width: ${minWidth}) {
			${baseSelector} {
				${rowRule}
			}
		}`;
		}

		return '';
	});

	return (
		<style>
			{rules.join('\n')}
		</style>
	);
}
